import { makeStyles, Theme } from "@material-ui/core";

export interface INavigationItem {
    title: string;
    relativePath: string;
    onClick?(): void;
    nestedList?: Array<INavigationItem> | null;
}

export function ConvertToNavigationItemState(
    props: INavigationProps
): Array<INavigationItemState> | undefined {
    return props.navigationItems?.map(function(item) {
        return {
            item: item,
            open: false
        };
    });
}

export interface INavigationProps {
    navigationItems: Array<INavigationItem> | null;
    className?: string | undefined;
    classes?: INavigationStyle | undefined;
}

export interface INavigationItemState {
    item: INavigationItem;
    open: boolean;
}

export interface INavigationStyle {
    listItem?: any;
    list?: any;
}

//CAVEAT! These styles can NOT be overridden without passing new style object to classes prop
export const useStyles = makeStyles<Theme>((theme: Theme) => ({
    list: (props: INavigationStyle | undefined) => ({
        fontWeight: 500,
        fontFamily: "JMSans, Helvetica Neue, Arial, sans-serif",
        margin: props?.list?.margin ? props.list.margin : "0px"
    }),
    listItem: (props: INavigationStyle | undefined) => ({
        marginLeft: props?.listItem?.marginLeft
            ? props.listItem.marginLeft
            : "0px",
        "&:hover": {
            backgroundColor: theme.palette.secondary.main
        },
        cursor: "pointer",
        color: theme.palette.primary.main,
        fontSize: props?.listItem?.fontSize ? props.listItem.fontSize : "1.2em",
        display: props?.listItem?.display ? props.listItem.display : "inherit"
    }),
    collapseIcons: {
        verticalAlign: "middle",
        marginLeft: "auto",
        fontSize: "1.1em"
    },
    collapsedList: {
        paddingLeft: "10px"
    },
    noTracerVisionText: {
        textAlign: "center",
        paddingTop: "200px"
    }
}));
